/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Footer from "./footer";

/* Styles */
import styles from "./styles";

const ConfirmActionModal = ({showModal, setShowModal, modalIcon, modalTitle, modalDescription, submitCallback, btnSpinner, disableSubmit, customModalStyling, onExited, confirmOnly, cancelText, confirmText}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  const handleSaveModal = () => {
    submitCallback()
  }

  return (
    <UCModal
      className={ classes.modal }
      showModal={ showModal }
      onExited={ onExited }
      setShowModal={ setShowModal }
      modalIcon={ modalIcon }
      modalTitle={ modalTitle }
      modalDescription={ modalDescription }
      modalFooter={ <Footer setShowModal={setShowModal} handleSaveModal={handleSaveModal} btnSpinner={btnSpinner} disableSubmit={disableSubmit} confirmOnly={confirmOnly} cancelText={cancelText} confirmText={confirmText} /> }
      dataTestId="confirmActionModal"
    />
  )
}

export default ConfirmActionModal;